export default "__VITE_ASSET__DmdMYS3a__"